import React from "react";
import { Form } from "react-bootstrap";
import { MasterCheckItem } from "../../../../components/masterData/MasterCheckList";
import MasterFormActions from "../../../../components/masterData/MasterFormActions";
import MasterSelect, {
  MasterSelectOption,
} from "../../../../components/masterData/MasterSelect";
import MasterTextField from "../../../../components/masterData/MasterTextField";
import styles from "../../../../components/masterData/MasterData.module.scss";
import { DeaneryParishAssignments } from "./DeaneryParishAssignments";

export type DeaneryFormValues = {
  deaneryName: string;
  deaneryCode: string;
  deanVicar: string;
  parishLifeLiaison: string;
  liaisonPhone: string;
  parishCategoryId: string;
};

export function DeaneryForm({
  isEditing,
  validated,
  values,
  categories,
  onChange,
  onSubmit,
  onCancel,
  saving = false,
  parishItems = [],
  parishFilter = "",
  onParishFilter,
  onToggleParish,
}: {
  isEditing: boolean;
  validated: boolean;
  values: DeaneryFormValues;
  categories: MasterSelectOption[];
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onCancel: () => void;
  saving?: boolean;
  parishItems?: MasterCheckItem[];
  parishFilter?: string;
  onParishFilter?: (value: string) => void;
  onToggleParish?: (id: string | number) => void;
}) {
  return (
    <Form onSubmit={onSubmit} noValidate validated={validated}>
      <div className={styles.formGrid}>
        <MasterSelect
          required
          label="Diocese / Category"
          name="parishCategoryId"
          value={values.parishCategoryId}
          placeholder="Select diocese / category"
          options={categories}
          invalidMessage="Diocese / category is required."
          onChange={onChange}
        />
        <MasterTextField
          required
          label="Deanery Name"
          name="deaneryName"
          value={values.deaneryName}
          placeholder="Deanery name"
          invalidMessage="Deanery name is required."
          onChange={onChange}
        />
        <MasterTextField
          required
          label="Deanery Code"
          name="deaneryCode"
          value={values.deaneryCode}
          placeholder="Deanery code"
          invalidMessage="Deanery code is required."
          onChange={onChange}
        />
        <MasterTextField
          label="Dean / Vicar"
          name="deanVicar"
          value={values.deanVicar}
          placeholder="Optional"
          onChange={onChange}
        />
        <MasterTextField
          label="Parish Life Liaison"
          name="parishLifeLiaison"
          value={values.parishLifeLiaison}
          placeholder="Optional"
          onChange={onChange}
        />
        <MasterTextField
          label="Liaison Phone"
          name="liaisonPhone"
          value={values.liaisonPhone}
          placeholder="Optional"
          onChange={onChange}
        />
        {values.parishCategoryId && onParishFilter && onToggleParish ? (
          <div className={styles.formGridFull}>
            <Form.Label>Parishes</Form.Label>
            <DeaneryParishAssignments
              items={parishItems}
              filter={parishFilter}
              onFilter={onParishFilter}
              onToggle={onToggleParish}
            />
          </div>
        ) : null}
      </div>
      <MasterFormActions
        isEditing={isEditing}
        onCancel={onCancel}
        showCancel={isEditing}
        disabled={saving}
      />
    </Form>
  );
}
